import { createRoot } from "react-dom/client";
import App from "./App";
import './i18n';
import { ParallaxProvider } from "react-scroll-parallax";
import { DevSupport } from "@react-buddy/ide-toolbox";
import { ComponentPreviews, useInitial } from "./dev";
import { HappyProvider } from "./context/happy_context";
import { initAutoTracking } from "./utils/analytics";

// Wire up document-level analytics listeners (scroll depth, time on page,
// click + form tracking, outbound links, visibility) once at app boot.
initAutoTracking();

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
const isLocalhost = ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname);
const isDevelopment = process.env.NODE_ENV === "development";
const defaultApiUrl = isLocalhost && isDevelopment
    ? "http://localhost:8000/api"
    : "https://api.happygastro.hu/api";

window.api = process.env.REACT_APP_HAPPY_API_URL || defaultApiUrl;

root.render(
    <HappyProvider>
        <ParallaxProvider>
            <DevSupport
                ComponentPreviews={ComponentPreviews}
                useInitialHook={useInitial}
            >
                <App />
            </DevSupport>
        </ParallaxProvider>
    </HappyProvider>
);
